// extracted by mini-css-extract-plugin
module.exports = {"page":"DefaultPage_page__1Dd15"};